export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/email-love.196a58e2.svg","height":32,"width":32};